import {
  VALIDATE_DYNAMIC_VOICE_CODE_REQUEST,
  VALIDATE_DYNAMIC_VOICE_CODE_SUCCESS,
  VALIDATE_DYNAMIC_VOICE_CODE_FAILURE,
  GET_TENANT_BRANDING,
} from "../Types/types";

const initialState = {
  dynamicVoiceValidating: false,
  dynamicVoiceConnectionDetails: null,
  tenantBranding: null,
};

export default function dynamicVoiceCallReducer(state = initialState, action) {
  switch (action.type) {
    case VALIDATE_DYNAMIC_VOICE_CODE_REQUEST:
      return { ...state, dynamicVoiceValidating: true };
    case VALIDATE_DYNAMIC_VOICE_CODE_SUCCESS:
      return { ...state, dynamicVoiceValidating: false, dynamicVoiceConnectionDetails: action.payload };
    case VALIDATE_DYNAMIC_VOICE_CODE_FAILURE:
      return { ...state, dynamicVoiceValidating: false };
    case GET_TENANT_BRANDING:
      return { ...state, tenantBranding: action.payload };
    default:
      return state;
  }
}
